// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotificationsAlert_root__H9t3X:hover {
  background: white !important;
}

.NotificationsAlert_title__q2g-8 {
  color: #8E8E93;
  font-size: 12px;
  font-style: normal;
  line-height: 14px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.NotificationsAlert_content__6T0w7 {
  color: #4778EE;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.NotificationsAlert_avatar__Zbjn7 {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/NotificationAlert/NotificationsAlert.module.scss","webpack://./src/assets/scss/mixins.scss"],"names":[],"mappings":"AAGE;EACE,4BAAA;AAFJ;;AAMA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;ECZA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADUF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ECpBA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADmBF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF","sourcesContent":["@import '@/assets/scss/mixins.scss';\n\n.root {\n  &:hover {\n    background: white !important;\n  }\n}\n\n.title {\n  color: #8E8E93;\n  font-size: 12px;\n  font-style: normal;\n  line-height: 14px;\n  font-weight: 400;\n\n  @include ellipsis;\n}\n\n.content {\n  color: #4778EE;\n  font-size: 14px;\n  font-weight: 500;\n  @include ellipsis;\n}\n\n.avatar {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n","@mixin ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@mixin invisible-scroll {\n  overflow: -moz-scrollbars-none;\n  overflow: -moz-hidden-unscrollable;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0 !important;\n    -ms-overflow-style: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NotificationsAlert_root__H9t3X`,
	"title": `NotificationsAlert_title__q2g-8`,
	"content": `NotificationsAlert_content__6T0w7`,
	"avatar": `NotificationsAlert_avatar__Zbjn7`
};
export default ___CSS_LOADER_EXPORT___;
